export const FETCH_HANDLERS_REQUEST = 'FETCH_HANDLERS_REQUEST';
export const FETCH_HANDLERS_SUCCESS = 'FETCH_HANDLERS_SUCCESS';
export const FETCH_HANDLERS_FAILURE = 'FETCH_HANDLERS_FAILURE';
export const CHANGE_HANDLER = 'CHANGE_HANDLER';